export default "__VITE_ASSET__aiMbv_nZ__"